// src/components/modals/ConfirmationModal.tsx (where WarningModal lives)
import React from 'react';
import { ActionButton } from '../../styles/profile/profile.style';
import { ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '../../styles/messenger/messenger.style';

interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;           // main sentence above the list
  bullets?: string[];         // << add this
  confirmText?: string;
}

export const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message = '',
  bullets = [],
  confirmText = 'Got it',
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>{title}</ModalHeader>

        <ModalBody>
          {message && <p style={{ margin: 0 }}>{message}</p>}
          {!!bullets.length && (
            <ul style={{ margin: '8px 0 0 1.25rem', padding: 0 }}>
              {bullets.map((b, i) => (
                <li key={i} style={{ marginBottom: 6 }}>{b}</li>
              ))}
            </ul>
          )}
        </ModalBody>

        <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ActionButton type="button" intent="primary" onClick={onConfirm}>
            {confirmText}
          </ActionButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};
